import { PreparedSortCriteria } from '@steelbuy/api-integration';
import {
    ListingBuyerSearchResultModel,
    ListingBuyerSearchResultModelConverter,
    ListingBuyerSearchSortCriteria,
    SearchFormData,
} from '@steelbuy/ts-shared';

import { useSaveListingViews } from '../../mutations/saveListingViews';
import cacheConfig from '../../utils/cacheOptions';
import { usePaginatedQuery } from '../../utils/usePaginatedQuery';

interface SearchListingOptions {
    searchData: SearchFormData;
    sortCriteria?: PreparedSortCriteria<ListingBuyerSearchSortCriteria>;
}
export const SEARCH_LISTING_KEY = 'search-listing';

const modelConverter = new ListingBuyerSearchResultModelConverter();
const searchListingMapFn = (data: ListingBuyerSearchResultModel) => modelConverter.toViewModel(data);

export const useSearchListings = (options: SearchListingOptions) => {
    const mutation = useSaveListingViews();
    return usePaginatedQuery<ListingBuyerSearchResultModel>({
        url: '/api/universal/search-listings',
        requestOptions: {
            filter: options.searchData,
            sort: options.sortCriteria,
        },
        mapFn: searchListingMapFn,
        queryKey: [SEARCH_LISTING_KEY, JSON.stringify(options)],
        queryOptions: {
            staleTime: cacheConfig['5_MINUTES'],
            onSuccess: ({ pages }) => {
                mutation.mutate({
                    listingIds: pages[pages.length - 1].items.map(({ listing: { id } }) => id),
                });
            },
        },
    });
};
